import * as React from 'react';
import classnames from 'classnames';
import { themr } from 'react-css-themr';
import { compose } from 'recompose';
import { translate } from 'react-i18next';

import Icon from 'common/components/core/icon';
import Chip from 'common/components/core/common/Chip';
import { IntersectionObserverDiv } from 'common/components/core/wrappers/Div';
import { PopoverPlaceEnum } from 'common/components/core/popover/popOverFactory';

import baseTheme from './ChipsList.scss';

class ChipsList extends React.Component {
    onPopoverButtonClick = e => {
        e.preventDefault();
        e.stopPropagation();
    };

    onIconClick = tagName => e => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onRightIconClick?.(tagName);
    };

    setBackground = tagName => {
        const { chipBackground } = this.props;

        if (typeof chipBackground === 'function') {
            return chipBackground?.(tagName);
        } else if (typeof chipBackground === 'string') {
            return chipBackground;
        }
    };

    render() {
        const {
            theme,
            className,
            value,
            getValueLabel,
            t,
            showOverflowCount,
            rightIcon,
            emptyStateText = t('addATag')
        } = this.props;

        if (!value || value.length === 0) {
            return (
                <div
                    className={classnames(theme.tagsWrap, {
                        [className]: className
                    })}
                >
                    <div className={theme.emptyTagsState}>
                        <Icon
                            theme={theme}
                            className={theme.addTagIcon}
                            icon={'plus-thin'}
                        />
                        <span className={theme.addTagText}>
                            {emptyStateText}
                        </span>
                    </div>
                </div>
            );
        }
        return (
            <div
                className={classnames(theme.tagsWrap, {
                    [className]: className
                })}
            >
                <IntersectionObserverDiv
                    className={theme.tagChipsWrap}
                    popoverPreferPlace={PopoverPlaceEnum.Below}
                    popoverClassName={theme.tagsIntersectionPopover}
                    onButtonClick={this.onPopoverButtonClick}
                    showOverflowCount={showOverflowCount}
                    theme={theme}
                >
                    {value.map(tagName => {
                        const text = getValueLabel?.(tagName) || tagName;
                        return (
                            <Chip
                                key={tagName}
                                className={theme.tagChip}
                                showOverflowTooltip
                                text={text}
                                theme={theme}
                                backgroundColor={
                                    this.setBackground(tagName) || null
                                }
                                rightIcon={rightIcon}
                                rightIconProps={{
                                    onClick: this.onIconClick(text)
                                }}
                            />
                        );
                    })}
                </IntersectionObserverDiv>
            </div>
        );
    }
}

export default compose(
    themr('ChipsList', baseTheme),
    translate('planner')
)(ChipsList);
